var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5 m-5"},[_c('header',{staticClass:"entry-header"},[_c('h1',{staticClass:"entry-title"},[_vm._v("Privacy Policy")])]),_c('div',{staticClass:"entry-content"})])
}]

export { render, staticRenderFns }